export const landingTranslations = {
  it: {
    hero: {
      badge: "Novità: AI Expert integrato",
      headline: "Gestisci concerti, fan e ricavi in un solo posto",
      subheadline: "Dashboard, calendario, revenue share e fan CRM: tutto quello che ti serve per far crescere il tuo business musicale. Configurazione in 5 minuti.",
      ctaPrimary: "Inizia gratis — senza carta di credito",
      ctaSecondary: "Guarda la demo (2 min)",
      trustBadge: "✓ Nessuna carta richiesta  ✓ GDPR compliant  ✓ Prova gratuita 14 giorni",
    },
    testimonials: {
      badge: "⭐⭐⭐⭐⭐ Amato da artisti e manager",
      stats: {
        revenue: "+€500K fatturato tracciato",
        concerts: "+10K concerti gestiti",
        users: "150+ utenti attivi",
      },
      items: [
        {
          name: "Christian DeLord",
          role: "Artista",
          quote: "Da quando uso MaestroCRM, ho aumentato le vendite di merchandise del 30% ai concerti",
        },
        {
          name: "Sara T.",
          role: "Booking manager",
          quote: "Gestivo tutto con Excel. Ora in 2 click vedo ricavi, contratti e disponibilità artisti",
        },
        {
          name: "Luca R.",
          role: "Venue owner",
          quote: "Il calcolo automatico delle revenue share mi fa risparmiare ore ogni settimana",
        },
      ],
    },
    nav: {
      features: "Funzionalità",
      pricing: "Prezzi",
      integrations: "Integrazioni",
      login: "Accedi",
      startFree: "Inizia gratis",
    },
    stats: {
      concerts: "Concerti gestiti",
      fans: "Fan tracciati",
      gdpr: "GDPR compliant",
      madeIn: "Made in Italy",
    },
    features: {
      title: "Tutto ciò di cui hai bisogno",
      subtitle: "Strumenti potenti per semplificare la gestione del tuo business musicale.",
      dashboard: {
        title: "Dashboard intelligente",
        description: "Vedi fatturato, concerti e trend a colpo d'occhio. Prendi decisioni migliori, più velocemente.",
      },
      concerts: {
        title: "Gestione concerti",
        description: "Dalla proposta alla chiusura: gestisci venue, artisti, budget e documenti senza perderti nulla.",
      },
      calendar: {
        title: "Calendario interattivo",
        description: "Visualizza e pianifica tutti i tuoi eventi in un'unica vista. Mai più sovrapposizioni.",
      },
      revenue: {
        title: "Revenue share",
        description: "Basta calcoli manuali. Definisci le percentuali e il sistema fa il resto.",
      },
      analytics: {
        title: "Analytics avanzate",
        description: "Scopri quali concerti rendono di più, quali trend seguire e dove investire.",
      },
      contacts: {
        title: "Gestione contatti",
        description: "Un CRM dedicato per artisti, venue, organizzatori e collaboratori. Tutto collegato ai concerti.",
      },
    },
    advancedFeatures: {
      badge: "Funzionalità avanzate",
      title: "Potenzia il tuo business",
      fanCrm: {
        title: "Fan CRM",
        description: "Gestisci il tuo pubblico con segmentazione avanzata e automazioni.",
      },
      ai: {
        title: "AI Expert",
        description: "Assistente AI specializzato per rispondere a ogni tua domanda.",
      },
      calculator: {
        title: "Calcolatore costi",
        description: "Simula scenari finanziari e calcola la redditività.",
      },
      contracts: {
        title: "Contratti",
        description: "Genera contratti professionali con template personalizzabili.",
      },
    },
    pricing: {
      title: "Piani per ogni esigenza",
      subtitle: "Inizia gratis. Scala quando vuoi.",
      viewAll: "Vedi tutti i piani",
      mostPopular: "Più popolare",
      perMonth: "/mese",
      startFree: "Inizia gratis",
      choosePlan: "Scegli il piano",
      free: {
        name: "Free",
        description: "Perfetto per provare",
        features: ["1 utente", "10 concerti/anno", "100 fan"],
      },
      artistPro: {
        name: "Artist Pro",
        description: "Per artisti che vogliono crescere",
        features: ["Fino a 30 concerti/anno", "200 fan CRM", "AI Expert (30/mese)", "2 integrazioni", "Media 500MB"],
      },
      manager: {
        name: "Manager",
        description: "Per chi gestisce più artisti",
        features: ["3 utenti", "150 concerti/anno", "3.000 fan", "AI (200/mese)", "5 integrazioni", "Media 5GB"],
      },
    },
    integrations: {
      badge: "Integrazioni",
      title: "Connetti i tuoi strumenti",
      ticketTailor: {
        name: "Ticket Tailor",
        description: "Sincronizza biglietti",
      },
      mailerLite: {
        name: "MailerLite",
        description: "Newsletter e automazioni",
      },
      paypal: {
        name: "PayPal",
        description: "Traccia pagamenti",
      },
      woocommerce: {
        name: "WooCommerce",
        description: "Negozio online",
      },
    },
    demo: {
      badge: "🎬 Guarda MaestroCRM in azione",
      subtitle: "Scopri quanto è semplice trasformare i tuoi fan in clienti fedeli",
      cta: "Provalo gratis — senza carta di credito",
      comingSoon: "Video in arrivo",
      highlights: [
        "Importa 1000 prodotti in 30 secondi",
        "L'AI consiglia i migliori upsell",
        "Calcola automaticamente le revenue share",
      ],
    },
    faq: {
      title: "Domande frequenti",
      items: [
        {
          question: "Ho bisogno di una carta di credito per la prova gratuita?",
          answer: "No! Inizia completamente gratis. Fai l'upgrade quando sei pronto.",
        },
        {
          question: "Quanto tempo richiede la configurazione?",
          answer: "Meno di 5 minuti. Crea l'account, importa i tuoi dati e sei operativo. Un wizard ti guida passo dopo passo.",
        },
        {
          question: "Posso importare i miei dati esistenti?",
          answer: "Sì! Importazione automatica da WooCommerce, TicketTailor, CSV o inserimento manuale.",
        },
        {
          question: "I miei dati sono sicuri e conformi al GDPR?",
          answer: "Assolutamente. Server in Europa, crittografia end-to-end, backup automatici giornalieri. Conforme al GDPR al 100%.",
        },
        {
          question: "Cosa succede quando raggiungo il limite di concerti?",
          answer: "Ti avvisiamo prima del limite. Fai l'upgrade in qualsiasi momento con un click.",
        },
        {
          question: "Posso cancellare in qualsiasi momento?",
          answer: "Sì. Cancella con un click, nessuna domanda. Esporta prima i tuoi dati.",
        },
        {
          question: "Offrite supporto?",
          answer: "Supporto email entro 24h per tutti i piani. Chat prioritaria e onboarding dedicato per i piani Pro e Manager.",
        },
        {
          question: "Più utenti possono accedere allo stesso account?",
          answer: "Sì! Invita i membri del team in base al tuo piano (da 1 a 10 utenti).",
        },
        {
          question: "Manca un'integrazione o una funzionalità che mi serve?",
          answer: "Nessun problema! Sviluppiamo integrazioni e funzionalità custom su richiesta. Contattaci per discutere le tue esigenze specifiche e ti faremo un preventivo personalizzato. Le integrazioni più richieste vengono aggiunte al prodotto per tutti.",
        },
      ],
    },
    cta: {
      title: "Inizia oggi, è gratis",
      subtitle: "Unisciti a centinaia di professionisti che hanno semplificato il loro business musicale.",
      primary: "Inizia gratuitamente",
      secondary: "Confronta i piani",
    },
    footer: {
      tagline: "Il CRM per professionisti della musica.",
      product: "Prodotto",
      company: "Azienda",
      resources: "Risorse",
      legal: "Legale",
      features: "Funzionalità",
      pricing: "Prezzi",
      integrations: "Integrazioni",
      roadmap: "Roadmap",
      about: "Chi siamo",
      careers: "Carriere",
      contact: "Contatti",
      press: "Press kit",
      blog: "Blog",
      helpCenter: "Help center",
      docs: "Documentazione",
      api: "API",
      status: "Status",
      privacy: "Privacy policy",
      terms: "Termini di servizio",
      gdpr: "GDPR",
      cookie: "Cookie policy",
      copyright: "Tutti i diritti riservati.",
      madeWith: "Made with ❤️ for musicians",
      newsletter: {
        title: "Ricevi aggiornamenti e novità sul prodotto",
        placeholder: "La tua email",
        button: "Iscriviti",
        success: "Grazie per l'iscrizione!",
      },
      companyInfo: {
        name: "InnoBrain JC Srl",
        vat: "P.IVA: 04024521207",
        address: "Via Michelino, 93/2 – 40126 Bologna (BO)",
        email: "info@maestrocrm.it",
        pec: "innobrain@pec.it",
      },
      trust: {
        gdpr: "GDPR compliant",
        ssl: "SSL secured",
        stripe: "Stripe verified",
      },
    },
  },
  en: {
    hero: {
      badge: "New: Integrated AI Expert",
      headline: "Manage Concerts, Fans & Revenue in One Place",
      subheadline: "Dashboard, calendar, revenue sharing and fan CRM: everything you need to grow your music business. Set up in 5 minutes.",
      ctaPrimary: "Start Free — No Credit Card",
      ctaSecondary: "Watch the 2-min demo",
      trustBadge: "✓ No credit card required  ✓ GDPR compliant  ✓ 14-day free trial",
    },
    testimonials: {
      badge: "⭐⭐⭐⭐⭐ Loved by Artists & Managers",
      stats: {
        revenue: "+€500K Revenue Tracked",
        concerts: "+10K Concerts Managed",
        users: "150+ Active Users",
      },
      items: [
        {
          name: "Christian DeLord",
          role: "Artist",
          quote: "Since using MaestroCRM, I've increased merchandise sales by 30% at concerts",
        },
        {
          name: "Sara T.",
          role: "Booking Manager",
          quote: "I managed everything in Excel. Now in 2 clicks I see revenue, contracts and artist availability",
        },
        {
          name: "Luca R.",
          role: "Venue Owner",
          quote: "Automatic revenue share calculation saves me hours every week",
        },
      ],
    },
    nav: {
      features: "Features",
      pricing: "Pricing",
      integrations: "Integrations",
      login: "Login",
      startFree: "Start Free",
    },
    stats: {
      concerts: "Concerts Managed",
      fans: "Fans Tracked",
      gdpr: "GDPR Compliant",
      madeIn: "Made in Italy",
    },
    features: {
      title: "Everything You Need",
      subtitle: "Powerful tools to simplify managing your music business.",
      dashboard: {
        title: "Smart Dashboard",
        description: "See revenue, concerts and trends at a glance. Make better decisions, faster.",
      },
      concerts: {
        title: "Concert Management",
        description: "From proposal to wrap-up: manage venues, artists, budgets and documents without missing a thing.",
      },
      calendar: {
        title: "Interactive Calendar",
        description: "View and plan all your events in one single view. No more scheduling conflicts.",
      },
      revenue: {
        title: "Revenue Share",
        description: "No more manual calculations. Set the percentages and the system does the rest.",
      },
      analytics: {
        title: "Advanced Analytics",
        description: "Discover which concerts perform best, which trends to follow, and where to invest.",
      },
      contacts: {
        title: "Contact Management",
        description: "A dedicated CRM for artists, venues, organizers and collaborators. All linked to your concerts.",
      },
    },
    advancedFeatures: {
      badge: "Advanced Features",
      title: "Power Up Your Business",
      fanCrm: {
        title: "Fan CRM",
        description: "Manage your audience with advanced segmentation and automations.",
      },
      ai: {
        title: "AI Expert",
        description: "Specialized AI assistant to answer all your questions.",
      },
      calculator: {
        title: "Cost Calculator",
        description: "Simulate financial scenarios and calculate profitability.",
      },
      contracts: {
        title: "Contracts",
        description: "Generate professional contracts with customizable templates.",
      },
    },
    pricing: {
      title: "Plans for Every Need",
      subtitle: "Start free. Scale when you're ready.",
      viewAll: "View all plans",
      mostPopular: "Most Popular",
      perMonth: "/month",
      startFree: "Start Free",
      choosePlan: "Choose plan",
      free: {
        name: "Free",
        description: "Perfect to try it out",
        features: ["1 user", "10 concerts/year", "100 fans"],
      },
      artistPro: {
        name: "Artist Pro",
        description: "For artists ready to grow",
        features: ["Up to 30 concerts/year", "200 fan CRM", "AI Expert (30/mo)", "2 integrations", "500MB media"],
      },
      manager: {
        name: "Manager",
        description: "For those managing multiple artists",
        features: ["3 users", "150 concerts/year", "3,000 fans", "AI (200/mo)", "5 integrations", "5GB media"],
      },
    },
    integrations: {
      badge: "Integrations",
      title: "Connect Your Tools",
      ticketTailor: {
        name: "Ticket Tailor",
        description: "Sync tickets",
      },
      mailerLite: {
        name: "MailerLite",
        description: "Newsletter & automations",
      },
      paypal: {
        name: "PayPal",
        description: "Track payments",
      },
      woocommerce: {
        name: "WooCommerce",
        description: "Online store",
      },
    },
    demo: {
      badge: "🎬 See MaestroCRM in Action",
      subtitle: "Watch how easy it is to turn your fans into loyal customers",
      cta: "Try it free — no credit card required",
      comingSoon: "Video coming soon",
      highlights: [
        "Import 1,000 products in 30 seconds",
        "AI recommends the best upsells",
        "Automatically calculate revenue shares",
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "Do I need a credit card for the free trial?",
          answer: "No! Start completely free. Upgrade when you're ready.",
        },
        {
          question: "How long does setup take?",
          answer: "Less than 5 minutes. Create your account, import your data and you're up and running. A wizard guides you step by step.",
        },
        {
          question: "Can I import my existing data?",
          answer: "Yes! Automatic import from WooCommerce, TicketTailor, CSV or manual entry.",
        },
        {
          question: "Is my data secure and GDPR compliant?",
          answer: "Absolutely. European servers, end-to-end encryption, automatic daily backups. 100% GDPR compliant.",
        },
        {
          question: "What happens when I reach the concert limit?",
          answer: "We notify you before the limit. Upgrade anytime with one click.",
        },
        {
          question: "Can I cancel anytime?",
          answer: "Yes. Cancel with one click, no questions asked. Export your data first.",
        },
        {
          question: "Do you offer support?",
          answer: "Email support within 24h for all plans. Priority chat and dedicated onboarding for Pro and Manager plans.",
        },
        {
          question: "Can multiple users access the same account?",
          answer: "Yes! Invite team members based on your plan (1–10 users).",
        },
        {
          question: "Missing an integration or feature I need?",
          answer: "No problem! We develop custom integrations and features on request. Contact us to discuss your specific needs and we'll give you a personalized quote. The most requested integrations are added to the product for everyone.",
        },
      ],
    },
    cta: {
      title: "Get Started Today — It's Free",
      subtitle: "Join hundreds of professionals who have already simplified their music business.",
      primary: "Start Free",
      secondary: "Compare plans",
    },
    footer: {
      tagline: "The CRM for music professionals.",
      product: "Product",
      company: "Company",
      resources: "Resources",
      legal: "Legal",
      features: "Features",
      pricing: "Pricing",
      integrations: "Integrations",
      roadmap: "Roadmap",
      about: "About us",
      careers: "Careers",
      contact: "Contact",
      press: "Press kit",
      blog: "Blog",
      helpCenter: "Help center",
      docs: "Documentation",
      api: "API",
      status: "Status",
      privacy: "Privacy policy",
      terms: "Terms of service",
      gdpr: "GDPR",
      cookie: "Cookie policy",
      copyright: "All rights reserved.",
      madeWith: "Made with ❤️ for musicians",
      newsletter: {
        title: "Get product updates & insights",
        placeholder: "Your email",
        button: "Subscribe",
        success: "Thanks for subscribing!",
      },
      companyInfo: {
        name: "InnoBrain JC Srl",
        vat: "VAT: 04024521207",
        address: "Via Michelino, 93/2 – 40126 Bologna (BO)",
        email: "info@maestrocrm.it",
        pec: "innobrain@pec.it",
      },
      trust: {
        gdpr: "GDPR Compliant",
        ssl: "SSL Secured",
        stripe: "Stripe Verified",
      },
    },
  },
} as const;

export type LandingLang = keyof typeof landingTranslations;
export type LandingTranslation = typeof landingTranslations.it;
